module.exports = __webpack_public_path__ + "static/img/pin-adulticide-scheduled.8f1f229.svg";